module.exports = __webpack_public_path__ + "media/src/public/images/mail/contract_notification/fistbump@3x-1a9c25e396ade52d8b93db2ff38f2230.png";